import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import "bootstrap/uly-wizard";

"use strict";
ko.bindingHandlers.wizard = {
    init: function(elt, va, bindings, model, context) {
        var validate = function(){
            var validatables = $(elt).find(".bs-step:eq("+current_step()+")").find("[validate=\"validate\"]");
            return  validate_fields(validatables, 1) === true;
        };
        var sidebar = $(elt).find(".bs-wizard-sidebar");
        var trigger = ko.observable(0);
        var tab_behaviour = ko.unwrap(va()) === false;
        var innerBindingContext = context.extend({
            recalculate: function() {
                setTimeout(function(){
                    if (trigger() > 0)
                        trigger(trigger() +1);
                    $(elt).uly_wizard("show_step");
                },0);
            },
            activateStep: function(ui, ev) {
                var $step = $(ev.target);
                var index = $step.index();
                var currentIndex = $elt.uly_wizard("current_step");
                if (index < currentIndex) {
                    $elt.uly_wizard("show_step", index);
                    trigger(trigger()+1);
                } else if (index > currentIndex && tab_behaviour) {
                    $elt.uly_wizard("show_step", index);
                    trigger(trigger()+1);
                } else if (index === currentIndex + 1) {
                    $elt.uly_wizard("go_next");
                    trigger(trigger()+1);
                }
            }
        });
        var $elt = $(elt);

        console.log("va:", va, "context:", context, "innerContext:", innerBindingContext);
        ko.applyBindingsToDescendants(innerBindingContext, elt);
        var is_first_visible_step = ko.pureComputed(function() {
            //ensure we subscribe to trigger
            var t = trigger();
            if (t > 0) {
                var step = $elt.uly_wizard("current_step");
                console.log("got step:", step, step === 0);
                return (step === 0);
            }
            return true;
        });
        var is_last_visible_step = ko.pureComputed(function() {
            //ensure we subscribe to trigger
            var t = trigger();
            if (t > 0) {
                var step = $elt.uly_wizard("current_step");
                var steps = $(".bs-step", $(elt));
                console.log("got step:", step, " for steps:", steps.length, step === steps.length - 1);
                return (step === steps.length - 1);
            }
            return true;
        });
        var wizard = $(elt).uly_wizard({
            show_func: function($elt) {
                $elt.fadeIn();
            },

            onInit:function(){
                var buttons = ko.unwrap(context.$parent.buttons);
                $.each(buttons, function(i, obj){
                    var bt = this;
                    if (bt.button == "ok"){
                        if (!tab_behaviour) {
                            is_last_visible_step.subscribe(function() {
                                bt.hidden(!is_last_visible_step());
                            });
                        } else {
                            bt.hidden(false);
                        }
                    }
                });
                buttons.splice(0, 0, {
                    action : function(e){return $(elt).uly_wizard("go_back", e);},
                    button : "prev",
                    button_class : "btn btn-default",
                    caption:"",
                    hidden_on_first:true,
                    icon:"fa fa-backward",
                    hidden: is_first_visible_step
                },{
                    action : function(e){return $(elt).uly_wizard("go_next", e);},
                    button : "next",
                    button_class : "btn btn-default",
                    caption:"",
                    icon:"fa fa-forward",
                    hidden_on_last:true,
                    hidden: is_last_visible_step
                });
                setTimeout(function() { trigger(trigger()+1);}, 0);
            },
            nextText: uly.strings.next,
            backText: uly.strings.prev,
            nextClasses: "btn btn-default wizard-next hidden",
            backClasses: "btn btn-default wizard-prev hidden",
            beforeNext:validate,
            onNext: function(){
                console.log("onNext");
                trigger(trigger()+1);
                return true;
            },
            onBack: function() {
                console.log("onBack");
                trigger(trigger()+1);
                return true;
            }
        });

        $(elt).find(".last-back").click(function() { wizard.uly_wizard("go_back") });
        $(elt).validate({
            beforeShowError: function(){
                if($(this).hasClass("error")){
                    $(this).parents(".form-group").removeClass("has-error").addClass("has-error");
                    sidebar.find("li:eq("+(current_step()-1)+")").removeClass("bs-wizard-completed");
                }else{
                    $(this).parents(".form-group").removeClass("has-error");
                }

            },
            highlight: function(element, errorClass, validClass) {
                $(element).addClass(errorClass).removeClass(validClass);
                $(element).parents(".form-group").addClass("has-error");
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).addClass(validClass).removeClass(errorClass);
                $(element).parents(".form-group").removeClass("has-error");
            }
        });
        function validate_fields(fields, step) {
            var error_step = null, field, _i, _len;
            for (_i = 0, _len = fields.length; _i < _len; _i++) {
                field = fields[_i];
                if (!form_validator().element(field)) {
                    error_step = step;
                }
            }
            return error_step !== null ? error_step : true;
        }

        function form_validator() {
            return $(elt).validate();
        }

        function current_step() {
            console.error("current_step:", $(elt).uly_wizard("current_step"));
            return $(elt).uly_wizard("current_step");
        }
        function is_last_step() {
            return current_step() === wizard.find(".bs-step").length;
        }
        $(window).resize(function() {
            $.validator.reposition();
        });
        return { controlsDescendantBindings: true };
    },
    update: function(elt, va, bindings, model, context) {
    }
};
